module.exports = __webpack_public_path__ + "static/not-found-1bcf1d8abd4bdeca0aa08118f7dbfee6.svg";